import ArticleCard from "@src/app/components/ArticleCard";
import SectionContainer from "@src/app/components/SectionContainer/SectionContainer";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import { createMetaTags } from "@src/app/utils/createMetaTags";

import { fetchEventsPageData } from "./Events.server";

export const loader = fetchEventsPageData;

export const meta = () => {
  return createMetaTags();
};

export default function EventsPage() {
  const route = useRouteResponse("eventsPage");
  const events = route.events;

  return events.map((event) => {
    const more = event.articles?.length ? event.tagUrlPath : undefined;

    return (
      <SectionContainer title={event.title} key={event.title} more={more}>
        <div className="px-3 py-4">
          <img src={event.banner} alt={event.title} />
        </div>

        <div className="grid grid-cols-12">
          {(event.articles || []).map((article) => {
            return (
              <ArticleCard
                key={article.id}
                article={article}
                className="col-span-12 lg:col-span-4"
              />
            );
          })}
        </div>
      </SectionContainer>
    );
  });
}
